import { colorsPalettes } from "@similarweb/styles";
import type { IDescriptionDropdownItemProps } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { emptyKeywordGroup } from "app/pages/keyword-analysis/KeywordGroupEditorHelpers";

import { ICampaignType } from "./SearchTrackerFromKeywordsTableTypes";

const ICON_COLOR = colorsPalettes.carbon[200];

export const NO_DATA = -2;

export const BRAND_MONITORING_CAMPAIGN_WIZARD_STATE = "brandmonitoring.wizard";
export const RANK_TRACKER_CAMPAIGN_WIZARD_STATE = "ranktracker.wizard";

export const getCampaignDataForDropDown = (): IDescriptionDropdownItemProps[] => [
    {
        iconName: "sidebar3-rank-tracker",
        description: translate("search.tracker.dropdown.rank.tracker.campaign.description"),
        title: translate("search.tracker.dropdown.rank.tracker.campaign.title"),
        iconColor: ICON_COLOR,
        id: ICampaignType.RankTracker,
    },
    {
        iconName: "sidebar3-brand-protection",
        description: translate("search.tracker.dropdown.brand.protection.campaign.description"),
        title: translate("search.tracker.dropdown.brand.protection.campaign.title"),
        iconColor: ICON_COLOR,
        id: ICampaignType.BrandProtection,
    },
];

export enum SearchTrackerFromKeywordsTableReducerTypes {
    SET_SHOULD_DISPLAY_CAMPAIGNS = "SET_SHOULD_DISPLAY_CAMPAIGNS",
    SET_CAMPAIGN_TYPE = "SET_CAMPAIGN_TYPE",
    SET_IS_LOADING = "SET_IS_LOADING",
    SET_IS_AUTOCOMPLETE_OPEN = "SET_IS_AUTOCOMPLETE_OPEN",
    SET_WARNING_STATE = "SET_WARNING_STATE",
    SET_CAMPAIGNS_RT = "SET_CAMPAIGNS_RT",
    SET_CAMPAIGNS_BP = "SET_CAMPAIGNS_BP",
    SET_SORTED_CAMPAIGNS = "SET_SORTED_CAMPAIGNS",
    SET_CAMPAIGNS = "SET_CAMPAIGNS",
    SET_GROUP = "SET_GROUP",
    SET_USER_CAMPAIGNS_DATA_SETTINGS = "SET_USER_CAMPAIGNS_DATA_SETTINGS",
    SET_SELECTED_CAMPAIGN = "SET_SELECTED_CAMPAIGN",
}

export const initialState = {
    shouldDisplayCampaigns: false,
    campaignType: ICampaignType.RankTracker,
    isLoading: false,
    isAutocompleteOpen: false,
    warningState: null,
    campaignsRT: [],
    campaignsBM: [],
    sortedCampaigns: null,
    campaigns: [],
    group: emptyKeywordGroup,
    userCampaignsDataSettings: null,
    keywordListId: null,
    prevState: { state: null, params: {} },
    selectedCampaign: {},
};

export function reducer(state, action) {
    switch (action.type) {
        case SearchTrackerFromKeywordsTableReducerTypes.SET_SHOULD_DISPLAY_CAMPAIGNS:
            return { ...state, shouldDisplayCampaigns: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_CAMPAIGN_TYPE:
            return { ...state, campaignType: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_IS_LOADING:
            return { ...state, isLoading: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_IS_AUTOCOMPLETE_OPEN:
            return { ...state, isAutocompleteOpen: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_WARNING_STATE:
            return { ...state, warningState: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_CAMPAIGNS_RT:
            return { ...state, campaignsRT: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_CAMPAIGNS_BP:
            return { ...state, campaignsBM: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_SORTED_CAMPAIGNS:
            return { ...state, sortedCampaigns: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_CAMPAIGNS:
            return { ...state, campaigns: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_GROUP:
            return { ...state, group: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_USER_CAMPAIGNS_DATA_SETTINGS:
            return { ...state, userCampaignsDataSettings: action.payload };
        case SearchTrackerFromKeywordsTableReducerTypes.SET_SELECTED_CAMPAIGN:
            return { ...state, selectedCampaign: action.payload };
        default:
            return state;
    }
}
